import React, { useMemo } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

/**
 * Container for all Zinnia components. Currently only necessary if you want to prepend Emotion styles at the top of the `head` in order to override component styles.
 */
export function ZinniaProvider({
  children,
  shouldPrependEmotionStyles = false,
}: {
  children: React.ReactNode;
  /** If `true`, prepends Emotion style tags in the `head`. Doing so allows CSS module styles to override components' Emotion styles. */
  shouldPrependEmotionStyles?: boolean;
}) {
  const cache = useMemo(
    () =>
      createCache({
        key: 'css',
        // `prepend: true` moves Emotion styles to the top of the <head> so they're loaded first. This order allows developers to override Emotion styles with other styling solutions, like CSS modules (which are placed at the bottom of the <head>).
        prepend: true,
      }),
    []
  );

  return shouldPrependEmotionStyles ? (
    <CacheProvider value={cache}>{children}</CacheProvider>
  ) : (
    children
  );
}
